import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FollowUpMenuItem, FollowUpSelection } from '@models/follow-up-options.model';
import { FollowUpOptionsService } from '@services/api/follow-up-options.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lead-follow-up-popover',
  templateUrl: './lead-follow-up-popover.component.html',
  styleUrls: ['./lead-follow-up-popover.component.scss'],
})
export class LeadFollowUpPopoverComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isVisible = false;
  @Input() containerClass = 'is-follow';
  @Input() helpTarget = 'lead-detail-follow-up-schedule';
  @Input() isPickDate = false;
  @Input() minSelectableDate: Date;
  @Input() timerOptions: any[] = [];
  @Input() followUpTime: string = null;
  /** Id of the preset matching the lead's current follow up, highlighted in the list. */
  @Input() activeOptionId: string = null;
  @Output() close = new EventEmitter<void>();
  @Output() quickFollowUp = new EventEmitter<FollowUpSelection>();
  @Output() togglePickDate = new EventEmitter<void>();
  @Output() dateSelected = new EventEmitter<any>();
  @Output() timeChanged = new EventEmitter<void>();
  @Output() followUpTimeChange = new EventEmitter<string>();

  menuItems: FollowUpMenuItem[] = [];
  isEditorOpen = false;

  private optionsSubscription: Subscription;

  constructor(
    private followUpOptionsService: FollowUpOptionsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.followUpOptionsService.ensureLoaded();
    this.optionsSubscription = this.followUpOptionsService.options$.subscribe(() => this.refreshMenu());
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Displayed times are relative to now — recompute on open so a lead left idle for hours
    // doesn't offer a stale "Later Today".
    if (changes.isVisible && this.isVisible) {
      this.refreshMenu();
    }
  }

  ngOnDestroy(): void {
    this.optionsSubscription?.unsubscribe();
  }

  onQuickFollowUp(item: FollowUpMenuItem): void {
    const selection = this.followUpOptionsService.selectionFor(item.id);
    if (selection) {
      this.quickFollowUp.emit(selection);
    }
  }

  openEditor(): void {
    this.isEditorOpen = true;
  }

  trackById(_index: number, item: FollowUpMenuItem): string {
    return item.id;
  }

  private refreshMenu(): void {
    this.menuItems = this.followUpOptionsService.menuItems();
    this.cdr.markForCheck();
  }
}
